import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiCollectionRepository, Result } from '@softline/core';
import { SOFTLINE_API_BELEGARTEN, SOFTLINE_API_GESAMTAFRAGE_QUERY } from '../gesamtabfrage.api';
import { Beleg } from '../types/beleg.model';
import { Belegart } from '../types/belegart.model';

@Injectable()
export class BelegartRepository extends ReadonlyHttpApiCollectionRepository<Result<Belegart[]>> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_BELEGARTEN);
  }
}
